export default "__VITE_ASSET__ChW0_ThY__"